<template>
    <v-container>

      <v-layout row justify-center mb-5>
        <v-flex>
          <v-avatar :size="250">
            <img src="@/assets/fdi-logo-white.png" alt="Fooddoneit Inc">
          </v-avatar>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-flex xs11 md4>
          <v-card class="elevation-12">
            <v-toolbar dark color="primary">
              <v-toolbar-title>Enter Confirmation Code</v-toolbar-title>
            </v-toolbar>
            <v-card-text>
              Check your email for your confirmation code!
            </v-card-text>
            <v-card-text>
              <v-form>
                <v-text-field
                
                  prepend-icon="person"
                  v-model="username"
                  name="username"
                  label="Username"
                  type="text"
                  id="username">
                </v-text-field>
                <v-text-field
                  prepend-icon="confirmation_number"
                  v-model="code"
                  v-on:keyup.enter="confirm"
                  label="Confirmation Code"
                  type="password"
                  id="code">
                </v-text-field>
              </v-form>
            </v-card-text>
            <v-card-actions>
              <v-btn color="secondary" v-on:click="resend">Resend Code</v-btn>
              <v-spacer></v-spacer>
              <v-btn color="primary" v-on:click="confirm" :disabled="!code">Confirm</v-btn>
            </v-card-actions>
          </v-card>
        </v-flex>
      </v-layout>
      <v-layout row justify-center>
        <v-flex xs-11 md4 v-if="error">
          <v-alert value="error"  type="error">
            {{ error }}
          </v-alert>
        </v-flex>
      </v-layout>
    </v-container>
</template>

<script>
import { Auth, Logger } from 'aws-amplify'
import AmplifyStore from '@/store'

const logger = new Logger('ConfirmSignUpComp');

export default {
  name: 'SignIn',
  data () {
    console.log(AmplifyStore.state.tempUserName)
    return {
        username: AmplifyStore.state.tempUserName,
        password: AmplifyStore.state.tempUserPassword,
        code: '',
        error: ''
    }
  },
  computed: {
    user() { return AmplifyStore.state.amplify.user }
  },
  methods: {
    confirm: function(event) {
        Auth.confirmSignUp(this.username, this.code)
            .then((res) => {
              var username = AmplifyStore.state.tempUser.username
              var password = AmplifyStore.state.tempUser.password
              Auth.signIn(username, password)
                .then(user => {
                  logger.debug('sign in success', user);
                  AmplifyStore.commit('setTempUser', null)
                  AmplifyStore.commit('setUser', user);
                  this.$router.push('/')
                })
                .catch(err => {
                  console.log(err)
                  this.setError(err)
                })
            })
            .catch(err => {
              console.log(err)
              this.setError(err)
            });
    },
    resend: function() {
        Auth.resendSignUp(this.username)
            .then(() => logger.debug('code resent'))
            .catch(err => this.setError(err));
    },
    signIn: function() {
        this.$router.push('/auth/signIn');
    },
    setError: function(err) {
        this.error = err.message || err;
    }
  }
}
</script>
